<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">
  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <!-- <fa-icon class="fas checklistIcon" title="click for smart checklist" (click)="openSmartChecklist()" [icon]="faCircle">
          </fa-icon> -->
          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faMountain"></fa-icon>
          <!-- <fa-icon class="fas fa-lg autoCursor" *ngIf="smartChecklist == false" title="click for smart checklist" (click)="openSmartChecklist()"  [icon]="faMountain"></fa-icon> -->
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize cursorArrow">{{ 'menu.landscape' | translate }}</h6>
      </div>
      <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-5 cursorArrow">
        <p class="titleParagraph">{{'landscape.toolHeaderLine1' | translate}}<br>
          {{'landscape.toolHeaderLine2' | translate}}
        </p>
      </div>

      <div class="col col-2 col-md-2 col-lg-2 col-sm-2 col-xs-2">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <span>
                <a type="button" (click)="openChatGPTassist()">
                  <fa-icon class="fas fa-lg toolLogoYellow" [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" (click)="sendJson()">
                  <fa-icon class="fas fa-lg" [icon]="faSitemap" title="mindmap"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" data-toggle="modal" data-target="#ytVideoLinkLS">
                  <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span class="autoCursor" (click)="generateReport('true')">
                <fa-icon class="fas fa-lg" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td rowspan="2">
              <span class="autoCursor ">
                <fa-icon class="fas fa-lg extraIcon" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>

        </table>
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <div class="landscape tool-body-height">
    <div class="card p-1 mb-2 bg-black h-100">
      <div class="row strict">
        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab" id="designerActiveTab" class="textClrWhite" (click)="changePriorTab('persona')"
              ng-attr-data-target="#personaTab">{{'deepDive.personaTab' | translate }}</a>
          </li>
          <li (click)="changePriorTab('env')">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#envTab">{{'deepDive.envTab' | translate
              }}</a>
          </li>

        </ul>
      </div>
      <div class="tab-content test-designer-nav-tab-content-height card" style="overflow: hidden !important;">
        <div ng-attr-id="personaTab" *ngIf="currentTab == 'persona'" class="tab-pane fade active in h-100">
          <div class="row strict h-100 pb-3">
            <div class="col-md-4 h-100 height105">
              <!-- <div class="col-xs-12 tab-separable h-100"> -->
              <!-- <div class="">
                <b class="font-weight-900 paddingright2px">
                  {{ 'landscape.modulesHeader' | translate }}&nbsp;({{modelData.modules.length}}) / {{
                  'landscape.entitiesHeader' | translate }}&nbsp;({{modelData.listOfEUTs.length}})
                </b>
              </div> -->
              <div class="row strict border-white border-bottom-none">
                <ul class="nav nav-tabs">
                  <li class="active" (click)="changeTab('module');clearEntityDetails()" id="featureTab">
                    <a data-toggle="tab" ng-attr-data-target="#fe">
                      <b>
                        {{ 'landscape.modulesHeader' | translate}}&nbsp;
                        ({{modelData.modules.length}})
                      </b>
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 1px;" [icon]="faRedo" title="clear"
                        (click)="clearModuleData()"></fa-icon>&nbsp;
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 7px;" [icon]="faTrash" title="delete"
                        (click)="selectedModuleObj.mName && deleteModuleModal()"></fa-icon>&nbsp;
                      <!-- <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faPlusSquare"
                        title="add" *ngIf="!selectedModuleObj.mName"
                        (click)="CreateModule(selectedEditModule,'Mo')"></fa-icon> -->
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faSave" title="save"
                        (click)="CreateModule(selectedEditModule,'Mo')"></fa-icon>
                    </a>
                  </li>
                  <li (click)="changeTab('entity');clearEntityDetails()" id="requirementTab">
                    <a data-toggle="tab" ng-attr-data-target="#ur">
                      <b>
                        {{ 'landscape.personaHeader' | translate}}&nbsp;
                        ({{modelData.persona.length}})
                      </b>

                      <fa-icon class="fas addDeleteButtons" style="margin-right: 1px;" [icon]="faRedo" title="clear"
                        (click)="clearPersonaDetails()"></fa-icon>&nbsp;
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 7px;" [icon]="faTrash" title="delete"
                        (click)="selectedPersonaObj.pName && deletePersonaModal()"></fa-icon>&nbsp;
                      <!-- <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faPlusSquare"
                        title="add" *ngIf="!selectedPersonaObj.pName"
                        (click)="CreatePersona(selectedEditPersona)"></fa-icon> -->
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faSave" title="save"
                        (click)="CreatePersona(selectedEditPersona)"></fa-icon>
                    </a>
                  </li>
                </ul>
              </div>
              <div
                class="tab-content table-content with-border landscape-entities card  p-0 mb-2 bg-black border-top-none">
                <!-- textarea shows when user updating or deleting entity-TF -->
                <div class="row" style="padding: 0px !important;">
                  <input *ngIf="selectedModuleObj.mName && tabType == 'module'" id="moduletextarea"
                    class="form-control transparent landscape-input-field" rows="1"
                    [placeholder]="'landscape.moduleUpdate'|translate"
                    style="background-color : lightyellow !important;" autosize="true" [(ngModel)]="selectedEditModule"
                    ngDefaultControl (keyup.enter)="CreateModule(selectedEditModule,'Mo')">
                  <!-- </input> -->

                  <!-- textarea shows when user not selected any entity-TF to update or delete -->
                  <input *ngIf="!selectedModuleObj.mName && tabType == 'module'" id="moduletextarea"
                    class="form-control transparent landscape-input-field" rows="1"
                    [placeholder]="'landscape.moduleAdd'|translate" style="background-color : lightyellow !important;"
                    autosize="true" [(ngModel)]="selectedEditModule" ngDefaultControl
                    (keyup.enter)="CreateModule(selectedEditModule,'Mo')">
                  <!-- </textarea> -->
                  <input *ngIf="selectedPersonaObj.pName && tabType == 'entity'"
                    class="form-control transparent landscape-input-field" id="personatextarea" rows="1"
                    [placeholder]="'landscape.personaUpdate'|translate" autosize="true"
                    [(ngModel)]="selectedEditPersona" ngDefaultControl
                    (keyup.enter)="CreatePersona(selectedEditPersona)"
                    style="background-color : lightyellow !important;">
                  <!-- </input> -->
                  <!-- textarea shows when user not selected any persona to update or delete -->
                  <input *ngIf="!selectedPersonaObj.pName && tabType == 'entity'"
                    class="form-control transparent landscape-input-field" id="personatextarea" rows="1"
                    [placeholder]="'landscape.personaAdd'|translate" autosize="true" [(ngModel)]="selectedEditPersona"
                    ngDefaultControl (keyup.enter)="CreatePersona(selectedEditPersona)"
                    style="background-color : lightyellow !important;">
                  <!-- </input> -->
                </div>

                <div ng-attr-id="fe"
                  class="tab-pane fade in active overflowYTextAuto landscape-entities-table-body-height">
                  <table class="table margintop1px table-sm ui-sort-table mb-0 " *ngIf="tabType == 'module'">
                    <tbody ui-sortable [(ngModel)]="modelData.modules" ngDefaultControl>
                      <tr class="ui-sortable-item strict" *ngFor="let mod of modelData.modules" auto-crud="true">
                        <td class="col-xs-12">
                          <label class="form-control transparent labelReadOnly text-align-justify cursorPointer" id="featureEdit"
                            (click)="selectedModule(mod)">{{mod.mName}}</label>
                        </td>
                      </tr>
                      <tr *ngIf="modelData.modules.length == 0">
                        <td class="col-xs-12 no-padding text-color-white">
                          <span>{{ 'landscape.emptyModule' | translate }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table margintop1px table-sm ui-sort-table mb-0 " *ngIf="tabType == 'entity'">
                    <tbody class="h-100" ui-sortable [(ngModel)]="modelData.persona" ngDefaultControl>
                      <tr class="ui-sortable-item strict" *ngFor="let per of modelData.persona" auto-crud="true">

                        <td class="col-xs-12">
                          <label class="form-control transparent labelReadOnly cursorPointer" id="personaEdit"
                            (click)="selectedPersona(per)">
                            {{per.pName}}</label>

                        </td>
                      </tr>
                      <tr *ngIf="modelData.persona.length == 0">
                        <td class="no-padding">
                          <span>{{ 'landscape.emptyPersona' | translate }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- <div ng-attr-id="ur"
                  class="tab-pane fade in active overflowYTextAuto landscape-entities-table-body-height"
                  >
                  
                </div> -->
              </div>
              <!-- </div> -->
            </div>
            <div class="col-md-8 h-100 height111">
              <!-- <div class="col-xs-12 tab-separable h-100"> -->
              <!-- <div class="">
                    <b class="font-weight-900 paddingright2px">
                      {{ 'landscape.modulesHeader' | translate }}&nbsp;({{modelData.modules.length}}) / {{
                      'landscape.entitiesHeader' | translate }}&nbsp;({{modelData.listOfEUTs.length}})
                    </b>
                  </div> -->
              <div class="row strict border-white border-bottom-none">
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a data-toggle="tab">
                      <b>
                        {{'landscape.entitiesHeader' | translate}}&nbsp;
                        ({{modelData.listOfEUTs.length}})
                      </b>
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 1px;" [icon]="faRedo" title="edit"
                        (click)="clearEntityDetails()"></fa-icon>&nbsp;
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 7px;" [icon]="faTrash" title="delete"
                        (click)="selectedEntityObj.eName && deleteEntityModal()"></fa-icon>&nbsp;
                      <!-- <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faPlusSquare"
                        title="add" *ngIf="!selectedEntityObj.eName"
                        (click)="CreateEntity(selectedEditEntity)"></fa-icon> -->
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faSave" title="save"
                        (click)="selectedEditModule && CreateEntity(selectedEditEntity)"></fa-icon>
                    </a>
                  </li>

                </ul>
              </div>
              <!-- <div class="col-xs-12 "> -->
              <!-- <div class="">
                <b class="font-weight-900 paddingright2px">
                  {{'landscape.entitiesHeader' | translate }}&nbsp;({{modelData.listOfEUTs.length}})
                </b>
              </div> -->
              <div
                class="tab-content table-content with-border landscape-entities card  p-0 mb-2 bg-black border-top-none">
                <div class="row" style="padding: 0px !important;">
                  <!-- <div class="col-md-2 paddingright2px">
                    <div class="dropdown">
                      <button
                        class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown">
                        <div class="row strict">
                          <div class="col-xs-7 span-on-button ">
                            <span>
                              {{choosenModule.mName || 'landscape.chooseModule' | translate}}
                            </span>
                          </div>
                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu text-color-black w-100 scrollable-menu">
                        <li class="row padding-vertical pl-2 pr-2" *ngFor="let mod of sortBy('mName')"
                          (click)="chooseModule(mod)">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                            {{mod.mName}}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div> -->
                  <div class="col-md-1 paddingright2px">
                    <div class="dropdown">
                      <button
                        class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown" [ngClass]="{ dis:EntityType}">
                        <div class="row strict">
                          <div class="col-xs-7 span-on-button ">
                            <span>
                              {{choosenType | translate}}
                            </span>
                          </div>
                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu text-color-black w-25 scrollable-menu cursorPointer">
                        <li class="row padding-vertical pl-2 pr-2" *ngFor="let type of types"
                          (click)="chooseType(type)">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                            {{type}}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-1 paddingright2px">
                    <div class="dropdown">
                      <button
                        class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown">
                        <div class="row strict">
                          <div class="col-xs-7 span-on-button ">
                            <span>
                              {{choosenEntityType | translate}}
                            </span>
                          </div>
                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu text-color-black w-25 scrollable-menu cursorPointer">
                        <li class="row padding-vertical pl-2 pr-2" *ngFor="let eType of entityTypes"
                          (click)="chooseeType(eType)">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                            {{eType}}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-10 h-100">
                    <div class="dropdown">
                      <button
                        class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown" [ngClass]="{ dis:primaryEntity}">
                        <div class="row strict">
                          <div class="col-xs-7 span-on-button ">
                            <span>
                              {{choosenPrimaryEntity.eName || 'landscape.chooseBaseEntity' | translate}}
                            </span>
                          </div>
                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu text-color-black w-100 scrollable-menu cursorPointer">
                        <span>
                          <li (click)="choosePrimaryEUT('')">&nbsp; anonymous</li>
                        </span>
                        <span *ngFor="let eut of modelData.listOfBaseEUTs">

                          <li class="row padding-vertical pl-2 pr-2" (click)="choosePrimaryEUT(eut)"
                            *ngIf="eut.mID == choosenModule.mID">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                              {{eut.eName}}
                            </div>
                          </li>
                        </span>
                      </ul>
                    </div>
                  </div>

                </div>
                <div class="row" style="padding: 0px !important;">
                  <input *ngIf="selectedEntityObj.eName" id="entitytextareaUR"
                    class="form-control transparent landscape-input-field" rows="1"
                    [placeholder]="'landscape.entityUpdate'|translate"
                    style="background-color : lightyellow !important;" autosize="true" [(ngModel)]="selectedEditEntity"
                    ngDefaultControl (keyup.enter)="selectedEditModule && CreateEntity(selectedEditEntity)">
                  <!-- </input> -->

                  <!-- textarea shows when user not selected any entity-TF to update or delete -->
                  <input *ngIf="!selectedEntityObj.eName" id="entitytextareaUR"
                    class="form-control transparent landscape-input-field" rows="1"
                    [placeholder]="'landscape.entityAdd'|translate" style="background-color : lightyellow !important;"
                    autosize="true" [(ngModel)]="selectedEditEntity" ngDefaultControl
                    (keyup.enter)="selectedEditModule && CreateEntity(selectedEditEntity)">
                  <!-- </input> -->
                </div>
                <div ng-attr-id="ur" class="tab-pane fade in active overflowYTextAuto">
                  <table class="table margintop1px table-sm ui-sort-table mb-0 ">
                    <tbody ui-sortable [(ngModel)]="modelData.listOfEUTs" ngDefaultControl>
                      <tr class="ui-sortable-item strict" *ngFor="let eut of modelData.listOfEUTs" auto-crud="true">
                        <td class="col-xs-12" *ngIf="eut.mID == choosenModule.mID">
                          <label class="form-control transparent labelReadOnly text-align-justify cursorPointer" id="requirementEdit"
                            (click)="selectedEntity(eut)">{{eut.eName}}</label>
                        </td>
                      </tr>
                      <tr *ngIf="modelData.listOfEUTs.length == 0">
                        <td class="col-xs-12 no-padding text-color-white cursorArrow">
                          <span>There are no entities to display.</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- </div> -->
              </div>
            </div>

          </div>
          <!-- <div class="row strict h-73">
            
          </div> -->
        </div>
        <div ng-attr-id="envTab" *ngIf="currentTab == 'env'" class="tab-pane fade active in h-100">
          <div class="row strict h-49 pb-3 landscaperEnvPart">
            <div class="col-xs-12 h-100">
              <div class="">
                <b class="font-weight-900 paddingright2px cursorArrow">
                  {{ 'landscape.envHeader' | translate }}&nbsp;({{modelData.listOfEnv.length}})
                </b>
              </div>
              <div class="row strict landscape-environments">
                <div class="row strict h-100">
                  <table class="table env p-0 mb-0 bg-black" style="border:1px solid white">
                    <thead class="">
                      <!-- style="width: calc(100% - 15px) !important;" -->
                      <tr>
                        <th class="col-xs-4 border-right1px cursorArrow">
                          {{ 'landscape.envSubHeaderType' | translate }}
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 1px;" [icon]="faRedo" title="clear"
                            (click)="clearEnvDetails()"></fa-icon>&nbsp;
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 7px;" [icon]="faTrash"
                            title="delete" (click)="selectedEnvObj.envType && deleteEnvModal()"></fa-icon>&nbsp;
                          <!-- <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faPlusSquare"
                            title="add" *ngIf="!selectedEnvObj.envType"
                            (click)="CreateEnvironment(selectedEditEnvType)"></fa-icon> -->
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faSave" title="save"
                            (click)="CreateEnvironment(selectedEditEnvType)"></fa-icon>
                        </th>
                        <th class="col-xs-8 cursorArrow">
                          {{ 'landscape.envSubHeaderValue' | translate }}
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 1px;" [icon]="faRedo" title="clear"
                            (click)="clearEnvDetails()"></fa-icon>&nbsp;
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 7px;" [icon]="faTrash"
                            title="delete" (click)="selectedEnvObj.envType && deleteEnvModal()"></fa-icon>&nbsp;
                          <!-- <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faPlusSquare"
                            title="add" *ngIf="!selectedEnvObj.envType"
                            (click)="CreateEnvironment(selectedEditEnvType)"></fa-icon> -->
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faSave" title="save"
                            (click)="CreateEnvironment(selectedEditEnvType)"></fa-icon>
                        </th>
                      </tr>
                      <tr>
                        <td class="col-xs-4 border-right1px p-0">
                          <!-- textarea shows when user updating or deleting env type -->
                          <input *ngIf="selectedEnvObj.envType" auto-crud-source
                            class="form-control transparent landscape-input-field"
                            [placeholder]="'landscape.envTypeUpdate'|translate"
                            style="background-color : lightyellow !important;" rows="1" autosize="true"
                            [(ngModel)]="selectedEditEnvType" ngDefaultControl id="environmenttextarea"
                            (keyup.enter)="CreateEnvironment(selectedEditEnvType)">
                          <!-- </input> -->

                          <!-- textarea shows when user not selected any env type to update or delete -->
                          <input *ngIf="!selectedEnvObj.envType" auto-crud-source
                            class="form-control transparent landscape-input-field"
                            [placeholder]="'landscape.envTypeAdd'|translate"
                            style="background-color : lightyellow !important;" rows="1" autosize="true"
                            [(ngModel)]="selectedEditEnvType" ngDefaultControl id="environmenttextarea"
                            (keyup.enter)="CreateEnvironment(selectedEditEnvType)">
                          <!-- </input> -->
                        </td>
                        <td class="col-xs-8 p-0">
                          <input auto-crud-source class="form-control transparent landscape-input-field"
                            [placeholder]="'landscape.envTypeValue'|translate" id="environmenttextarea"
                            style="background-color : lightyellow !important;" rows="1" autosize="true"
                            [(ngModel)]="selectedEditEnvValues" (keyup.enter)="CreateEnvironment(selectedEditEnvType)"
                            ngDefaultControl>
                        </td>
                      </tr>
                    </thead>
                  </table>
                  <table class="table env mb-2 p-0 bg-black landscape-environments-table-list"
                    style="border:1px solid white">
                    <tbody class="h-100" ui-sortable>
                      <tr class="ui-sortable-item strict" *ngFor="let en of modelData.listOfEnv" auto-crud="true">
                        <td class="col-xs-4 border-right1px">
                          <label class="form-control transparent labelReadOnly cursorPointer" id="envEdit"
                            (click)="selectedEnvironment(en)">{{en.envType}}</label>
                          <!-- <textarea auto-crud-source class="form-control transparent" rows="1" autosize="true"
                              [(ngModel)]="modelData.listOfEnv[$index].envType"
                              ng-blur="landscape.onFocusOut(modelData.listOfEnv[$index].envType,$index);"></textarea> -->
                        </td>
                        <td class="col-xs-8">
                          <!-- <label class="form-control transparent labelReadOnly"
                                [(ngModel)]="modelData.listOfEnv[$index].envValues" 
                               ></label> -->
                          <!-- <textarea auto-crud-source class="form-control transparent env" rows="1" autosize="true"
                              [(ngModel)]="modelData.listOfEnv.envValues" ng-list
                              
                              required></textarea> -->
                          <label class="form-control transparent labelReadOnly cursorPointer"
                            (click)="selectedEnvironment(en)">{{en.envValues}}</label>
                        </td>
                      </tr>
                      <tr *ngIf="modelData.listOfEnv.length == 0">
                        <td colspan="2" class="col-xs-12 no-padding cursorArrow">
                          <!-- <button class="btn btn-default btn-block btn-xs mapperReadOnly"
                                (click)="add('' ,$index)">
                              <fa-icon class="fa icon icon-black" [icon]="faPlus"></fa-icon> -->
                          <span>{{ 'landscape.emptyEnv' | translate }}</span>
                          <!-- </button> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row strict h-49 pb-3 landscaperAtrPart">
            <div class="col-xs-12 h-100">
              <div class="">
                <b class="font-weight-900 paddingright2px cursorArrow">
                  {{ 'landscape.attributeHeader' | translate }}&nbsp;({{Config.listOfAttributesUpdated.length}})
                </b>
              </div>
              <div class="bottom-table landscape-attributes card p-0 mb-2 bg-black">
                <div class="inner-tab h-100">
                  <table class="table table-sm ui-sort-table mb-0">
                    <tbody ui-sortable>
                      <tr class="ui-sortable-item  strict border-bottom1px"
                        *ngFor="let attr of Config.listOfAttributesUpdated" auto-crud="true">
                        <!-- on-create="landscape.add('', $index)" on-delete="landscape.delete($index)"> -->

                        <td class="col-xs-4 border-right1px cursorArrow">
                          {{attr.name}}
                        </td>
                        <td class="col-xs-8">
                          <!-- <label auto-crud-source-readonly class="form-control transparent ellipsis" [(ngModel)]="landscape.attribute[$index].aDetail"></label> -->
                          <textarea class="form-control transparent overflowYTextAuto overflow-wrap-normal" rows="1"
                            id="attributetextarea" max-rows="3"
                            placeholder="{{attr.placeholder}}" (focusout)="updateAttributeDesc(attr,myTextarea.value)"
                            autosize="false" [value]="getAttributeDesc(attr)" #myTextarea></textarea>
                        </td>

                      </tr>
                      <!-- <tr *ngIf="modelData.listOfAttributes == 0">
                        <td class="col-xs-12">
                          <button class="btn btn-default btn-xs">
                            <fa-icon class="fa icon icon-black" [icon]="faPlus"></fa-icon>
                            <label>add attributes</label>
                          </button>
                        </td>
                      </tr> -->
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="false" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #1 : {{'landscape.tip1' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #2 : {{'landscape.tip2' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #3 : {{'landscape.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#myCarousel" data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#myCarousel" data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
  <!-- The persona or entity duplicate error message modal -->
  <div class="modal fade" id="duplicateErrorMessagePopupModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{duplicateEntity}}</label>
                </div>
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{errorMessage}}</label>
                </div>
                <div class="form-element text-align-center">
                  <button type="button" id="popupOkbutton"
                    class="btn btn-secondary modalActionBtn orgUserListOkbtn pr-0 pl-0" data-dismiss="modal">{{ 'ok' |
                    translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The Persona delete Confirm Message Modal -->
  <div class="modal fade" id="deleteLandscaperErrorMessagePopupModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal"
                  (click)="clearPersonaDetails()">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px contentEllipsis text-align-center" title={{duplicateEntity}}>
                    {{duplicateEntity}}
                  </label>
                </div>
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px text-align-center">{{errorMessage}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per" id="deletePersonaButton"
              (click)="deletePersona()">{{
              'yes' | translate }}</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal"
              (click)="clearPersonaDetails()">
              {{ 'no' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The Entity delete Confirm Message Modal -->


  <!-- The Env delete Confirm Message Modal -->
  <div class="modal fade" id="deleteLandscaperEnvErrorMessagePopupModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal" (click)="clearEnvDetails()">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px contentEllipsis text-align-center"
                    title={{duplicateEntity}}>{{duplicateEntity}}</label>
                </div>
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px text-align-center">{{errorMessage}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per" id="deleteEnvButton"
              (click)="deleteEnvironment()">{{ 'yes' | translate }}</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal"
              (click)="clearEnvDetails()">
              {{ 'no' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The Entity delete Confirm Message Modal -->
  <div class="modal fade" id="deleteLandscaperEntityErrorMessagePopupModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal" (click)="clearEntityDetails()">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px contentEllipsis text-align-center"
                    title={{duplicateEntity}}>{{duplicateEntity}}</label>
                </div>
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px text-align-center">{{errorMessage}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per" data-dismiss="modal"
              id="deleteEntityButton" (click)="deleteEUTdata();">{{
              'yes' | translate }}</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal"
              (click)="clearEntityDetails()">
              {{ 'no' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The Module delete Confirm Message Modal -->
  <div class="modal fade" id="deleteLandscaperModuleErrorMessagePopupModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal" (click)="clearEntityDetails()">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px contentEllipsis text-align-center"
                    title={{duplicateEntity}}>{{duplicateEntity}}</label>
                </div>
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px text-align-center">Would you like to delete all EUT's, Tasks,
                    Mappings in this module?</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per" data-dismiss="modal"
              id="deleteEntityButton" (click)="deleteModuledata();">{{
              'yes' | translate }}</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal"
              (click)="clearEntityDetails()">
              {{ 'no' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkLS" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkLS" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" (click)="terminateVideo()" id="terminateYoutubeVideo"
              data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title cursorArrow" id="myModalLabel">{{'youtubeVideoTitle.landscaper' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" id="LsVideoLink" class="youtubeVideo" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>